/*
 *
 * File JS section gallery
 *
 */

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./gallery-list.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const galleryList = () => {
    let allGalleryList = document.querySelectorAll(".gallery-list");

    if (!allGalleryList.length) return;

    allGalleryList.forEach((el, i) => {
        lightGallery(el.querySelector(".lightgallery"), {
            thumbnail: true,
            plugins: [lgThumbnail],
            exThumbImage: "data-exthumbimage",
            animateThumb: true,
            mobileSettings: {
                showCloseIcon: true,
            },
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: "WQ63Z-598QW-NZ7D5-WPMTB",
        });
    });
};

export default galleryList;

//--------------------------------------------------------------------//
